module.exports = __webpack_public_path__ + "img/bg-servicios-4.1cdb9d0f.png";